// tracking_scripts/tag4arm.ts

/**
 * Extends the global Window interface to include the _paq array.
 * The _paq array stores commands to be sent to the ExactTarget Marketing Cloud (ETMC).
 */
declare global {
	interface Window {
		/** Global array to store commands for the ExactTarget Marketing Cloud (ETMC). */
		_paq: Array<any>;
	}
}

/**
 * Initializes the _paq array for tracking, making it globally accessible via window._paq.
 * Sets up the default tracking commands and tracker URL.
 *
 * @returns {string} - The base URL for the tracker, dynamically determined based on the document protocol.
 */
export function initializePaq(): string {
	if (!window._paq) {
		window._paq = [];
	}

	// Define the protocol and base URL for the tracker dynamically
	const u =
		('https:' === document.location.protocol ? 'https' : 'http') +
		'://www.tag4arm.com/tags4arm/';

	// Set up the necessary tracking commands
	window._paq.push(['trackPageView']);
	window._paq.push(['enableLinkTracking']);
	window._paq.push(['setTrackerUrl', u + 'tag4arm.php']);
	window._paq.push(['setSiteId', '496']);

	return u; // Return the tracker URL for further use
}
